import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiAgentUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/agents",
  "/:app_group_id/generative_ai/agents/campaign_qa",
];
